import { render, staticRenderFns } from "./StoryMaker.vue?vue&type=template&id=097beb2c&scoped=true"
import script from "./StoryMaker.vue?vue&type=script&lang=js"
export * from "./StoryMaker.vue?vue&type=script&lang=js"
import style0 from "./StoryMaker.vue?vue&type=style&index=0&id=097beb2c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097beb2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097beb2c')) {
      api.createRecord('097beb2c', component.options)
    } else {
      api.reload('097beb2c', component.options)
    }
    module.hot.accept("./StoryMaker.vue?vue&type=template&id=097beb2c&scoped=true", function () {
      api.rerender('097beb2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/StoryMaker.vue"
export default component.exports